function ajaxCall(url, email, success_callback) {
    console.log(url)
    $.ajax({
        method:'POST',
        url: url,
        headers: {
            'X-CSRFToken': csrftoken
        },
        data : {
            email: email
        },
        success: success_callback,
        error: function(err) {
            console.log(err);
        }
    });
};

function ajaxUpdateCall(url, is_checked, success_callback) {
    console.log(url)
    $.ajax({
        method:'PATCH',
        url: url,
        headers: {
            'X-CSRFToken': csrftoken
        },
        data : {
            is_checked: is_checked
        },
        success: success_callback,
        error: function(err) {
            console.log(err);
        }
    });
};

function mailchimp_success() {
    console.log("mail ajouté à Mailchimp");
    $("#js-newsletter-success").show();
};

function mailchimp_update_success() {
    console.log("status Mailchimp changé");
};

$(function() {

    var emailRe = /^[a-zA-Z\._+0-9-]+@[a-zA-Z._0-9-]+\.[a-zA-Z]{2,10}$/;

    $("#js-newsletter-form").on("submit", function(e){
        // form to send email on Enter
        e.preventDefault();
        var email = $("#newsletter_input").val();
        if (emailRe.test(email)) {
            // console.log(email)
            ajaxCall('/api/newsletter', email, mailchimp_success);
            $("#js-newsletter-success").show();
            $("#js-newsletter-error").hide();
        } else {
            // console.log("N'est pas un email");
            $("#js-newsletter-success").hide();
            $("#js-newsletter-error").show();
        }
            $('#js-newsletter-msg').show().fadeOut(4000);
    });

    // $("#js-newsletter-subscription").on('change', function(){
    //     var is_checked = $(this).is(":checked");
    //     ajaxUpdateCall('/api/newsletter', is_checked, mailchimp_update_success);
    // });

    $("#profile_min_info_form").on('submit', function(){
        // console.log($("#js-newsletter-subscription").is(":checked"));
        // console.log($("#id_email").val());
        if ($("#js-newsletter-subscription").is(":checked")) {
            ajaxCall('/api/newsletter', $("#id_email").val(), mailchimp_success);
        }
    });
});
